import { lazy } from "react";
import { Navigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const CreateFunctionSuperAdmin = lazy(() => import("./CreateFunctionSuperAdmin"));
const DetailFunctionSuperAdmin = lazy(() => import("./DetailFunctionSuperAdmin"));
const ViewFunctionSuperAdmin = lazy(() => import("./ViewFunctionSuperAdmin"));

const L = DefaultLayout;
const W = withSuspense;

/** Redirects /function/:id to /function/:id/details so bare function URLs (e.g. after save or bookmarks) resolve. */
function RedirectFunctionToDetails() {
  const { id } = useParams();
  return <Navigate to={`/function/${id}/details`} replace />;
}

export function getFunctionSuperadminRoutes() {
  return [
    { path: "/create-function-superadmin/:projectId", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/create-function-superadmin", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/view-function-superadmin", layout: L, element: W(ViewFunctionSuperAdmin) },
    { path: "/function/:id", layout: L, element: <RedirectFunctionToDetails /> },
    { path: "/function/:id/edit", layout: L, element: W(CreateFunctionSuperAdmin) },
    { path: "/function/:id/details", layout: L, element: W(DetailFunctionSuperAdmin) },
    { path: "/functions/:id", layout: L, element: W(ViewFunctionSuperAdmin) },
  ];
}
